import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  HomeImageContainer
  , HomeContainer
  , HomeImage
  , HomeLoginContainer
  , FlexBox, LoginHeader, LoginInputField, LoginInputPassword, MailImage, PasswordImage, InputBox, TermConditionLine, TermConditionLine1, NewUser, SignUp, LoginButton, EmptyBox, LoginButtonContainer
  ,ForgotPassword
} from './styled';
import { Header } from '../../components/header/internals'
import Image from '../../assets/homeimage.svg'
import MailIcon from '../../assets/mail.svg'
import LockIcon from '../../assets/lock.svg'
import { Link } from 'react-router-dom'; 
import * as apiClient from "../../common/apiClient";



export const Home = () => {
  const [formFields, setFormFields] = useState({ emailId: '', password: '' })
  const [errorField, setErrorField] = useState<any>(null)
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<any>(false);
  const errorStyle = { 
    borderColor: 'red', 
  };
  const showToastMessage = (message: any) => {
    apiClient.showErrorMessage(message);
  };
  const showSuccessMessage = (message: any) => {
    apiClient.showSuccessMessage(message);
  };
  const handleOnChange = (event: any, identifier: any) => {
    
    let fields: any = { ...formFields };
    fields[identifier] = event.target.value;
    setErrorField(null);
    setFormFields(fields);

  };
  const handleSubmit = () => {

    if (formFields.emailId == null || formFields.emailId == undefined || formFields.emailId == '') {
      showToastMessage('Email Id is required');
      setErrorField('emailId')
      return;
    }
    if (!apiClient.validateEmail(formFields.emailId)) {
      showToastMessage('Please Enter Valid email');
      setErrorField('emailId')
      return;
    }

    if (formFields.password == null || formFields.password == undefined || formFields.password == '') {
      showToastMessage('Password is required');
      setErrorField('password')
      return;
    }

    let payload={
      username: formFields.emailId,
      password:  formFields.password,  
      usertype: "business",
      
    }
    
    apiClient.post('app-users/login', payload,null).then((response: any) => {
      setIsLoading(false); 
      if(response.result)
      {
        localStorage.setItem("business_partner_id",response.data.business_partner_id)
        localStorage.setItem("user_id",response.data.id)
        localStorage.setItem("user_type",response.data.user_type)
        sessionStorage.setItem('userType', response.data.user_type);
        sessionStorage.setItem('authenticated', '1');
        showSuccessMessage(response.message);
        if(response.data.user_type=="business")
        {

          navigate('/dashboard');    
        }
        else
        {
          navigate('/scan');    
        }
        
      }
      else
      {
        showToastMessage(response.message);
      }
    }).catch((err) => {
      setIsLoading(false);
    })
    
  }
  return (
    <HomeContainer>
      <Header />
      <FlexBox >
        <HomeImageContainer>
          <HomeImage src={Image} />
        </HomeImageContainer>

        <HomeLoginContainer>
          <LoginHeader>
            Please login to access your subscription
          </LoginHeader>
          <LoginInputField style={errorField == 'emailId' ? errorStyle : {}} >
            <MailImage src={MailIcon} ></MailImage>
            <InputBox type="text" placeholder='Enter your Email ID' value={formFields.emailId} onChange={(event) => handleOnChange(event, 'emailId')} ></InputBox>
          </LoginInputField>
          <LoginInputPassword style={errorField == 'password' ? errorStyle : {}} >
            <PasswordImage src={LockIcon} ></PasswordImage>
            <InputBox type="password" placeholder='Password' value={formFields.password} onChange={(event) => handleOnChange(event, 'password')}  ></InputBox>
          </LoginInputPassword>
          <TermConditionLine>
            By signing in or creating an account you agree with our
          </TermConditionLine>
          <TermConditionLine1>
            Terms & Conditions & Privacy Policy
          </TermConditionLine1>
          <NewUser>New User? <SignUp>
            <Link style={{
              color: '#4285F4', textDecoration: 'none',
              fontFamily: 'Montserrat',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: '20px',
              paddingLeft: '5px',
              cursor: 'pointer'
            }} to={'/signup'}>Sign up</Link>   </SignUp>
          </NewUser>
          
           <ForgotPassword>
            <Link style={{
              color: '#4285F4',
              textDecoration: 'none',
              fontFamily: 'Montserrat',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: '20px',
              paddingLeft: '5px',
              cursor: 'pointer'
            }} to={'/forgotpassword'}>Forgot Password</Link>   </ForgotPassword>
          
          <EmptyBox />
          <LoginButtonContainer>
            <LoginButton onClick={handleSubmit}>Login Now</LoginButton>
          </LoginButtonContainer>
        </HomeLoginContainer>

      </FlexBox>

    </HomeContainer>
  );
};
